import React from 'react'
import { DashboardLayout } from '../../layouts'
import { Breadcrumb } from '../../components'
import { FormMobile, ContentField, ContentVisibility, ListNav } from './components'
import { viewportBreakpoint, useViewport } from '../../utils'

const routes = [
  {
    name: 'Dashboard',
    route: '/dashboard'
  },
  {
    name: 'Inisiatif',
    route: '#'
  },
]

const DesktopComponent = ({activeTab, setActiveTab}) => {
  return (
    <DashboardLayout
      title="Edit Inisiatif"
    >
      <Breadcrumb routes={routes}/>
      <h1 className="text-4xl font-bold font-primary">
        Create / Edit Inisiatif
      </h1>
      <hr className="mt-5 mb-8"/>

      <ListNav activeTab={activeTab} onChange={setActiveTab}/>

      { activeTab === 'Field Inisiatif' && <ContentField /> }
      { activeTab === 'Visibility Setting' && <ContentVisibility /> }
    </DashboardLayout>
  )
}

const MobileComponent = ({activeTab, setActiveTab}) => {
  const withNav = true

  return (
    <DashboardLayout
      title="Create / Edit Inisiatif"
      mobileNav={withNav ? <ListNav activeTab={activeTab} onChange={setActiveTab}/> : undefined}
    >
      { activeTab === 'Field Inisiatif' && <FormMobile /> }
      { activeTab === 'Visibility Setting' && <ContentVisibility /> }
    </DashboardLayout>
  )
}

const DashboardProgramForm = () => {
  const { width } = useViewport()
  const isDesktop = width >= viewportBreakpoint.desktop
  const [activeTab, setActiveTab] = React.useState('Field Inisiatif')

  return isDesktop ? (
    <DesktopComponent
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  ) : (
    <MobileComponent
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  )
}

export { DashboardProgramForm }
